var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquipodetrabajo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 1280,
    viewBox: "0 0 800 1280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_631)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_220_631)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-22.2124 834.987C-35.2111 816.995 -62.6385 809.347 -63.5924 784.534C-64.5456 759.738 -59.2899 727.149 -45.6482 701.385C-33.2885 678.042 -64.4375 641.015 -48.5856 618.962C-28.4052 590.887 45.306 550.805 76.1167 543.152C108.923 535.004 116.703 599.238 144.441 607.301C167.069 613.878 199.973 593.081 221.07 602.155C243.969 612.004 257.395 634.169 264.01 658.73C271.159 685.274 280.224 718.064 260.042 746.855C238.747 777.233 193.317 773.879 165.464 799.308C139.054 823.419 137.709 865.764 108.348 885.344C79.321 904.701 43.1279 907.248 18.0862 897.589C-6.33515 888.17 -7.48857 855.367 -22.2124 834.987Z",
    fill: "url(#paint0_linear_220_631)",
    fillOpacity: 0.6
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_220_631",
    x: -119.701,
    y: 486.44,
    width: 448.062,
    height: 472.625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 28,
    result: "effect1_foregroundBlur_220_631"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_631",
    x1: 270.412,
    y1: 903.496,
    x2: 219.721,
    y2: 498.818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E24473"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#620C90"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_631"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1280,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipodetrabajo);
export default __webpack_public_path__ + "static/media/equipodetrabajo.77c9fa1fabaa7750b72d0e8cb62c89d2.svg";
export { ForwardRef as ReactComponent };